import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';
import { ContentTypesHeaderQuery } from '@confluence/content-types-utils/entry-points/ContentTypesHeaderQuery.graphql.ts';

export function preloadContentTypesHeader(contentId: string, useObjectHeader: boolean) {
	return query({
		/* @ts-expect-error -- http://go/cfe-use-relay-artifacts */
		query: ContentTypesHeaderQuery,
		variables: {
			contentId,
			useObjectHeader,
		},
	});
}
